export default "__VITE_ASSET__D8$_T$zw__"